import { features, stats } from '@/mocks/homeData';

export default function FeatureSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            为什么选择 <strong className="text-primary-500">j9平台</strong>
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            五大核心优势，为您打造极致娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feat, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-6 rounded-xl bg-background-100/70">
              <div className="font-heading text-3xl md:text-4xl font-bold text-accent-500 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}